import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { Button, Card, Container, Row, Col, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { verification } from "../../Redux/usersReduce";
import { saveReclamation, getDetailReclamation, updateReclamation, saveFile } from "../../Redux/reclamationReduce";
import PageOne from "../../components/Step/PageOne/PageOne";
import PageTwo from "../../components/Step/PageTwo/PageTwo";
import PageThree from "../../components/Step/PageThree/PageThree";
import MultiStepProgressBar from "../../components/Step/MultiStepProgressBar/MultiStepProgressBar";
import { toast, ToastContainer } from "react-toastify";
import PageZero from "../../components/Step/PageZero/PageZero";

function AjouterReclamation({ client }) {
  const t = useTranslation();
  const dispatch = useDispatch();
  const navigate = useHistory();
  const saveTableCalled = useRef(false);
  const location = useParams();
  var idClaim = location.id;

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }

  const [commentaire, setCommentaire] = React.useState(null);
  const [produitSelect, setProduitSelect] = React.useState(null);
  const [typeSelect, setTypeSelect] = React.useState(null);
  const [qte, setQte] = React.useState(0);
  const [lot, setLot] = React.useState(null);
  const [motifSelect, setMotifSelect] = React.useState(null);
  const [uploadFile, setUploadFile] = React.useState(null);

  const [bl, setBl] = React.useState([]);

  const verifToken = useCallback(async () => {
    var response = await dispatch(verification());
    if (response.payload === false) {
      localStorage.clear();
      window.location.replace("/login");
    } else {
      //setIdRole(response.payload.id_role)
    }
  }, [dispatch]);

  const getReclamation = useCallback(async (id) => {

    var response = await dispatch(getDetailReclamation(id));
    setCommentaire(response.payload.entete.commentaire)
    setProduitSelect(
      response.payload.entete.produits
        ? {
          value: response.payload.entete.produits.id,
          label: response.payload.entete.produits.Designation_1,
          code: response.payload.entete.produits.Code_PCT,
          code_article: response.payload.reclamations?.produits?.Code_article || null,
        }
        : null
    );

    setTypeSelect(
      response.payload.entete.types
        ? {
          label: response.payload.entete.types.nom,
          value: response.payload.entete.id_type,
        }
        : null
    );
    setLot(response.payload.entete.lot)
    setQte(response.payload.entete.qte)
    setMotifSelect({ label: response.payload.entete.motif_description, value: response.payload.entete.motif })

    var array = [];
    if (response.payload.ligne.length > 0)
      response.payload.ligne.forEach((e) => {
        const obj = {
          ...e.ligne_livraisons,
          quantite: e.quantite,
          Qte: e.quantite_livraison,
          date: e.date_expiration,
          DateExpiration: e.date_expiration,
          DateLivraison: e.Date_expedition,
          Date_expedition: e.Date_expedition,
          NumLivraison: e.numero_livraison

        };
        console.log(obj)
        array.push(obj)
      })
    setBl(array)
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await verifToken();
      if (idClaim) getReclamation(idClaim)
    };

    fetchData();
  }, []);

  const [page, setPage] = useState(idClaim ? "pageone" : "pagezero");

  const sumQuantities = () => {
    let verif = true;
    for (let item of bl) {
      if (item.quantite > item.Qte && item.quantite) {
        verif = false;
      }
    }
    return verif;
  };

  const sumQuantities2 = () => {
    let sum = 0;
    for (let item of bl) {
      if (item.quantite > 0) {
        sum += item.quantite;
      }
    }
    return sum;
  };
  const nextPage = async (page) => {
    if (page == "pagezero") {
      if (motifSelect != null) {
        setPage("pageone");
      }
      else {
        notify(2, t("erreur"));
      }
    } else if (page == "pageone") {
      if (produitSelect != null && ((typeSelect != null && (motifSelect.value == 3 || motifSelect.value == 1)) || typeSelect == null) && lot != null) {
        setPage("pagetwo");
      }
      else {
        notify(2, t("erreur"));
      }
    } else if (page == "pagetwo") {
      const totalQuantity = sumQuantities();
      const totalQuantity2 = sumQuantities2();
      if ((totalQuantity && (motifSelect.value == 3 || motifSelect.value == 1)) || (commentaire && (motifSelect.value == 2 || motifSelect.value == 4))) {
        if (saveTableCalled.current) return;
        saveTableCalled.current = true
        const dataArray = new FormData();
        let filename = null;

        if (uploadFile !== null) {
          dataArray.append("file", uploadFile);
          const namefile = uploadFile.name !== undefined ? uploadFile.name : null;
          dataArray.append("name", namefile);

          const resultat = await dispatch(saveFile(dataArray));
          filename = resultat.payload.filename;
        }


        if (idClaim) {

          dispatch(updateReclamation({ filename, qte: totalQuantity2, lot, bl, produitSelect, typeSelect, commentaire, idClaim, motifSelect })).then((e) => {
            if (e.payload === true) {
              notify(1, t("add_txt"));
              setPage("pagethree");
              setTimeout(() => {
                window.location.replace(client + "/reclamationList")
              }, 800);
            } else {
              saveTableCalled.current = false
              notify(2, t("erreur"));
            }
          })
        } else {
          dispatch(saveReclamation({ filename, qte: totalQuantity2, lot, bl, produitSelect, typeSelect, commentaire, client, motifSelect })).then((e) => {
            if (e.payload === true) {
              notify(1, t("add_txt"));
              setPage("pagethree");
              setTimeout(() => {
                window.location.replace(client + "/reclamationList")
              }, 800);
            } else {
              saveTableCalled.current = false
              notify(2, t("erreur"));
            }
          })
        }
      }
      else {
        saveTableCalled.current = false
        notify(2, t("erreur"));
      }
    }
  };
  const nextPageNumber = (pageNumber) => {
    switch (pageNumber) {
      case 0:
        setPage("pagezero");
        break;
      case 1:
        setPage("pageone");
        break;
      case 2:
        setPage("pagetwo");
        break;
      case 3:
        setPage("pagethree");
        break;
      default:
        setPage("pageone");
    }
  };

  return (
    <Container fluid>
      <ToastContainer />

      <Card>
        <Card.Header>
          <Card.Title as="h4">{t("Reclamation.add")}</Card.Title>
        </Card.Header>
        <Card.Body>
          {(idClaim && motifSelect != null || idClaim == undefined) && (
            <>
              <MultiStepProgressBar page={page} onPageNumberClick={nextPageNumber} />
              {
                {
                  pagezero: <PageZero onButtonClick={nextPage} client={client} getMotifSelect={motifSelect} setMotifSelect={setMotifSelect} />,
                  pageone: motifSelect != null && (motifSelect.value == 3 || motifSelect.value == 1) ?
                    <PageOne setBl={setBl} idClaim={idClaim} nextPageNumber={nextPageNumber} onButtonClick={nextPage} setProduitSelect={setProduitSelect} motifSelect={motifSelect} client={client} setQte={setQte} setLot={setLot} setTypeSelect={setTypeSelect} getProduitSelect={produitSelect} getQte={qte} getLot={lot} getTypeSelect={typeSelect} /> : <PageTwo client={client} nextPageNumber={nextPageNumber} onButtonClick={nextPage} produitSelect={produitSelect} lot={lot} qte={qte} setBl={setBl} setCommentaire={setCommentaire} getBl={bl} getCommentaire={commentaire} motifSelect={motifSelect} getUploadFile={uploadFile} setUploadFile={setUploadFile} idClaim={idClaim} />,
                  pagetwo: <PageTwo client={client} idClaim={idClaim} nextPageNumber={nextPageNumber} onButtonClick={nextPage} produitSelect={produitSelect} lot={lot} qte={qte} setBl={setBl} setCommentaire={setCommentaire} getBl={bl} getCommentaire={commentaire} motifSelect={motifSelect} getUploadFile={uploadFile} setUploadFile={setUploadFile} />,
                  pagethree: <PageThree onButtonClick={nextPage} />
                }[page]
              }
            </>
          )}

        </Card.Body>
      </Card>
    </Container>
  );
}

export default AjouterReclamation;
